import { Component, OnInit } from '@angular/core';
import { UserDetailResult } from 'src/app/model/UserDetail';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { UserModel } from 'src/app/model/UserModel';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { ProductService } from 'src/app/services/product.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { DataServiceService } from 'src/app/services/data-service.service';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { environment } from 'src/environments/environment';
import { DataUnitofMeasureInfo } from 'src/app/model/selfcareproducts';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.css']
})
export class LoanComponent implements OnInit {

  initloading: boolean = true;
  userdetail: UserDetailResult;
  firstname: string;
  planname: string;
  planstatus: string;
  activeProducts2: any;
  activeProducts: LteActiveSession[];
  customer: any;
  MDN1: string;
  totalGb: string;
  currentUsage: string;
  daysLeft: string;
  progress: any;
  currentUser: UserModel;
  selectedOptions: any;
  customerBalance: number;
  accType: any;
  loanCount: any;
  config = {
    displayKey: "Display", //if objects array passed which key to be displayed defaults to description
    search: true,
    height: '180px',
    searchOnKey: 'Display'
  };

  constructor(private toastr: ToastrService, private router: Router, private sharedService: SharedService, private productService: ProductService, private authenticationService: AuthenticationService, private accountService: AccountService, private dataService: DataServiceService) {
    this.currentUser = this.authenticationService.getCurrentUser();


    this.firstname = this.currentUser.FirstName;

    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;

   if(KycStatus)
   {
    if(KycStatus.toLowerCase() === "Rejected".toLowerCase() || KycStatus.toLowerCase() === "No Kyc".toLowerCase())
    { 
      this.router.navigate(['/kyc']); 

    }

  }
   }

    this.dataService.currentAccountType.subscribe(acc => {
      this.accType = acc;//? acc: true;
      this.fetchAccounts();

    });
  }

  ngOnInit() {
  }

  async selectionChanged(e) {
    if (e.value) {
      var acc = e.value.i_account;
      
      await this.getAccountDetail(acc);
    }
  }

  async getAccountDetail(i_account) {

    try {

      var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
      model.i_account = i_account;
      model.DownloadType = "ACC:GetDetail";

      let userDetailResult = await this.accountService.getAccountDetailFromLteHttp(model.i_account).toPromise();

      if (!userDetailResult) {
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }

      this.userdetail = userDetailResult.Result;

      var userdetail = this.userdetail;
      this.loanCount = userdetail.LoanCount ? userdetail.LoanCount : 0;
      this.MDN1 = userdetail.subscriber.FirstName ? `${userdetail.subscriber.FirstName} - ${userdetail.ID}` : userdetail.ID;

    }
    catch (err) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
    }

  }

  async fetchAccounts() {

    var my_object = this.currentUser;
    let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";

    if (my_object) {
      var iAccount = parseInt(my_object.i_Account);

      if (iAccount == 0)   //  customer with multiple accounts
      {
        //an individual
        activeSessionRequest.i_customer = parseInt(my_object.i_Customer);
        await this.setActiveSession(activeSessionRequest);

      }
      else  // single account
      {
        activeSessionRequest.i_account = parseInt(my_object.i_Account);
        this.setActiveSession(activeSessionRequest);
      }

    }
  }

  async setActiveSession(model: ActiveSessionsReqObj) {

    if (model) {
      let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      if (!res.Result) {
        this.toastr.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }
      let activeSessions: LteActiveSession[] = [] as LteActiveSession[];

      if (this.accType == "VOICE") {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice"));
      } else {
        activeSessions = <LteActiveSession[]>res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice"));
      }

      this.activeProducts = activeSessions.map(a => {
        return <any>{
          ID: a.ID,
          i_account: a.i_account,
          Display: a.subscriber.FirstName ? a.subscriber.FirstName + ' - ' + a.ID : a.ID,
          subscriber: a.subscriber
        }
      });

      var firstAcc = this.activeProducts[0];

      this.selectedOptions = {
        AccountName: firstAcc.AccountName,
        ID: firstAcc.ID,
        i_account: firstAcc.i_account,
        Display: firstAcc.subscriber.FirstName ? firstAcc.subscriber.FirstName + ' - ' + firstAcc.ID : firstAcc.ID
      }

      await this.getAccountDetail(firstAcc.i_account);

    }
  }

  fundwallet() {
    this.router.navigateByUrl('/funddatareserve');
  }

  requestloan() {

    if(this.userdetail.block==environment.pausedAccId){
      this.toastr.error("You cannot take loan with a paused account. Please contact Customer Care");
      return;
    }

if(this.userdetail.CustomerClass=='Enterprise'){
  this.toastr.error("Loan Restricted on Account");
  return;

}
    let account = this.userdetail;

    if (!account) {
      return;
    }

    let voiceproduct = account.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("loan request is only available on data plans", "Error");
      return;
    }

    this.router.navigateByUrl('/requestloan?acc=' + this.userdetail.i_account);

  }

}
